define([
	"dojo/_base/declare",
	"csi/api",
	"csi/html/Widget",
	"csi/printUtil"
], function(declare,api,Widget,printUtil) {

	return declare(Widget, {
		bPrintView: true,
		printOrientation: api.PORTRAIT,

		_onLoadTemplate: function() {
			// summary: assign paper width to content node
			var rootNode = this.getContentRoot();
			var pageSize = printUtil.getPageSizeForSettings(this.getPrintPaper(), this.getPrintOrientation());
			$(rootNode).width(pageSize.w);
		}
	});
});